import { render, staticRenderFns } from "./onlinePageSetting.vue?vue&type=template&id=24ba74b9&scoped=true&"
import script from "./onlinePageSetting.vue?vue&type=script&lang=js&"
export * from "./onlinePageSetting.vue?vue&type=script&lang=js&"
import style0 from "./onlinePageSetting.vue?vue&type=style&index=0&id=24ba74b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ba74b9",
  null
  
)

export default component.exports